/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useEffect, useState } from "react";

import cn from "classnames";

import isUndefined from "utils/isUndefined";
import normalize from "utils/normalize";
import Input from "./Input";
import Label from "../Label";

interface IRadioOption {
  value: string;
  label: string;
  id: string;
  checked?: false;
}

interface IRadioGroup {
  options: IRadioOption[];
  value?: string;
  className?: string;
  inputContainerClassName?: string;
  name: string;
  onChange: (e: any) => any;
  labelArgs?: any;
}

const RadioGroup = ({
  options,
  value,
  name,
  labelArgs,
  className,
  inputContainerClassName,
  ...args
}: IRadioGroup) => {
  const [activeValue, setActiveValue] = useState(value || options[0].value);
  useEffect(() => {
    if (value) setActiveValue(value);
  }, [value]);

  return (
    <div className={cn("flex flex-col", className)} test-id="QaXMFmxk">
      {options?.length &&
        options.map((option) => {
          const { value: optionValue, label, id, ...rest } = option;

          const htmlFor = id || label || optionValue;
          const value = optionValue || id;
          // Just making sure it is set.
          if (isUndefined(activeValue)) {
            setActiveValue(options[0].value);
          }

          return (
            <div
              key={id}
              className={cn(
                "relative flex items-center space-x-s10",
                inputContainerClassName,
              )}
              test-id="DQ4GkoNO"
            >
              <Input
                type="radio"
                size="sm"
                name={name}
                checked={normalize(activeValue) === normalize(value)}
                {...rest}
                {...args}
                id={htmlFor}
                value={value}
                onChange={(e) => {
                  const target = e.target as HTMLInputElement;
                  // @ts-ignore
                  rest?.onChange?.(e);
                  args?.onChange?.(e);
                  setActiveValue(target.value);
                }}
              />

              <Label
                hasMargin={false}
                size="small"
                htmlFor={htmlFor}
                {...labelArgs}
                test-id="kldCV7It"
              >
                {label || value}
              </Label>
            </div>
          );
        })}
    </div>
  );
};

export default RadioGroup;
